import React from 'react';
import { Typography } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { DateTime } from 'luxon';

import { getTimezoneText } from './helpers';

type Props = WithStyles<typeof styles> & {
  currentDateTime: DateTime;
  day: string;
  localTimezone: string;
};

const DayHeader: React.FC<Props> = ({ classes, currentDateTime, day, localTimezone }) => (
  <div className={classes.dayHeader}>
    <Typography className={classes.sessionDayText}>
      {currentDateTime.set({ day: Number(day) }).toFormat('EEEE')},{' '}
      {currentDateTime.toFormat('MMMM')} {day}
    </Typography>

    <Typography className={classes.timezoneHint}>{getTimezoneText(localTimezone)}</Typography>
  </div>
);

const styles = () =>
  createStyles({
    dayHeader: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
    },
    sessionDayText: {
      fontSize: 16,
      fontWeight: 900,
    },
    timezoneHint: {
      marginLeft: 25,
    },
  });

export default withStyles(styles)(DayHeader);
